import { useEffect, useState } from 'react';
import styles from './SecondUserTaxForm.module.scss';
import { TaxInputInf, TaxTypes } from '../../../interfaces/interfaces';
import { Field, Form } from 'react-final-form';
import { MdInfoOutline as InfoIcon } from 'react-icons/md'
import OutlinedFormInput from '../components/OutlinedFormInput/OutlinedFormInput';
import { onBlurFormatNumber, parseNumberForDB } from '../../../components/functions/utilities';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import { FaCircleExclamation as Exclamation } from "react-icons/fa6";
import { HiOutlineReceiptTax as TaxIcon } from 'react-icons/hi';
import { RestS } from '../../../rest/rest-service';

type Props = {
    taxInputData: TaxInputInf,
    refreshTabs: () => void;
}

const SecondUserTaxForm = ({ taxInputData, refreshTabs }: Props) => {
    const [initialValues, setInitialValues] = useState({});
    const [submitValues, setSubmitValues] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (taxInputData) {
            setInitialValues({
                taxType: taxInputData.taxType,
                value: taxInputData.value,
            })
        } else {
            setInitialValues({
                taxType: TaxTypes.fixed,
                value: null,
            })
        }
    }, []);

    const handleSubmit = (values) => {
        console.log('submitting values', values)
        setSubmitValues(values);
        setShowConfirmation(true);
    }

    const submitTaxes = async () => {
        if (submitValues) {
            try {
                setLoading(true);
                const submittedValues = await RestS.submitTaxInput({
                    taxType: submitValues.taxType,
                    value: submitValues.value,
                });
                refreshTabs();
            } catch (error) {
                console.log('error', error);
            } finally {
                setShowConfirmation(false);
                setLoading(false);
            }
        }
    }

    return (
        <>
            <div className={styles.taxesRootContainer}>
                {taxInputData?.taxType == TaxTypes.notApplicable ?
                    <div className={styles.noFormStateContainer}>
                        <div className={styles.iconContainer}>
                            <TaxIcon />
                        </div>
                        <div className={styles.textContainer}>
                            <div className={styles.title}>
                                You've Selected for GST to Be Inapplicable for Your Products.
                            </div>
                            <div className={styles.subTitle}>
                                Contact us to update.
                            </div>
                        </div>
                    </div>
                    : taxInputData?.taxType == TaxTypes.fixed ?
                        <>
                            <Form
                                initialValues={initialValues}
                                onSubmit={handleSubmit}
                                validate={(values) => {
                                    const errorValues = {};
                                    if (!values?.value) {
                                        errorValues['value'] = 'Enter GST';

                                    } else if (values?.value && (values?.value < 0 || values?.value > 100)) {
                                        errorValues['value'] = 'GST must be between 0 and 100';
                                    }
                                    return errorValues;
                                }}
                                render={({ pristine, values, handleSubmit, form, hasValidationErrors }) => {
                                    return (
                                        <form onSubmit={handleSubmit}>
                                            <div className={styles.formBodyContainer}>
                                                <div className={styles.topHeadingContainer}>
                                                    <div className={styles.iconContainer}>
                                                        <TaxIcon />
                                                    </div>
                                                    <div className={styles.textContainer}>
                                                        Your Products Follow a Fixed GST Rate.
                                                    </div>
                                                </div>
                                                <Field name='value'>
                                                    {(props) => {
                                                        return (
                                                            <div className={styles.fieldRowRootContainer}>
                                                                <div className={styles.fieldRowContainer}>
                                                                    <div className={styles.leftContainer}>
                                                                        <div className={styles.taxValueInputContainer}>
                                                                            <OutlinedFormInput
                                                                                {...props.input}
                                                                                // placeholder='GST'
                                                                                showError={false}
                                                                                inpuType="number"
                                                                                name={props.input.name}
                                                                                value={props.input.value}
                                                                                onChange={(e) => {
                                                                                    const numericValue = parseNumberForDB(e.target.value, true);
                                                                                    props.input.onChange(numericValue);
                                                                                }}
                                                                                error={props.meta.error}
                                                                                touched={props.meta.touched}
                                                                                onBlur={(e) => {
                                                                                    const value = props.input.value;
                                                                                    console.log('value', value)
                                                                                    const formattedValue = onBlurFormatNumber(value, 2);
                                                                                    props.input.onChange(formattedValue);
                                                                                    props.input.onBlur(e);
                                                                                }}
                                                                                unitPlaceHolder={"%"}
                                                                                unitPosition={"right"}
                                                                                maxLength={10}
                                                                                isCurrency={false}
                                                                                showBorder={true}
                                                                            />
                                                                        </div>
                                                                        <div className={styles.supportText}>
                                                                            of Net Sales Price
                                                                        </div>
                                                                    </div>
                                                                    <div className={styles.rightContainer}>
                                                                        <MeritoButton disabled={pristine || hasValidationErrors} onClick={handleSubmit} type='primary-1' size='md' btnText='Update GST' />
                                                                    </div>
                                                                </div>
                                                                <div className={styles.errorContainer}>
                                                                    {props.meta.error && props.meta.touched ? <div className={styles.errorText}>{props.meta.error}</div> : null}
                                                                </div>
                                                            </div>
                                                        )
                                                    }}
                                                </Field>
                                            </div>
                                        </form>
                                    )
                                }}
                            />
                        </>
                        : taxInputData?.taxType == TaxTypes.variable ?
                            <div className={styles.noFormStateContainer}>
                                <div className={styles.iconContainer}>
                                    {/* <InfoIcon /> */}
                                    <TaxIcon />
                                </div>
                                <div className={styles.textContainer}>
                                    <div className={styles.title}>
                                        Your Products Have Different GST Rates.
                                    </div>
                                    <div className={styles.subTitle}>
                                        Update GST for products from the Product Costs section.
                                    </div>
                                </div>
                            </div>
                            : null}
            </div>

            <ConfirmDialog
                modalStyles={{ maxWidth: '450px' }}
                showButton={false}
                visible={showConfirmation}
                toggle={() => {
                    setShowConfirmation(!showConfirmation);
                }}
                showCloseBtn={false}
                size={"md"}
            >
                <div className={styles.confirmationContainer}>
                    <div className={styles.topContainer}>
                        <div className={styles.iconContainer}>
                            <Exclamation />
                        </div>
                        <div className={styles.title}>
                            Update GST?
                        </div>

                        <div className={styles.warningText}>
                            {`This will impact the numbers from the last 12 months.`}
                            <br />
                            <br />
                        </div>
                    </div>

                    <div className={styles.bottomContainer}>
                        <MeritoButton onClick={() => {
                            setShowConfirmation(false);
                        }} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText={'Cancel'} />
                        <MeritoButton loading={loading} size="lg" onClick={submitTaxes} isRounded={true} btnType="button" type="primary-1" btnText="Update" />
                    </div>
                </div>
            </ConfirmDialog>
        </>
    );
}

export default SecondUserTaxForm;